import { Swiper, Navigation, Pagination, EffectFade } from 'swiper';

Swiper.use([Navigation, Pagination, EffectFade]);

const sliderBreakpoints = {
  320: 1.6,
  480: 1.6,
  768: 3.6,
  1340: 3.6,
  1800: 3.6,
};

export default (node) => {
  const sliderEl = node.querySelector('[data-slider]');
  const paginationEl = node.querySelector('[data-slider-pagination]');
  const nextEl = node.querySelectorAll(`[data-slider-next]`);
  const prevEl = node.querySelectorAll(`[data-slider-prev]`);

  let mainSwiper = null;

  const nextSlide = () => {
    mainSwiper.slideNext();
  };

  const prevSlide = () => {
    mainSwiper.slidePrev();
  };

  const changePaginationPosition = () => {
    const slideHeight = node.querySelector(
      '[data-swiper-slide-image]'
    ).offsetHeight;
    const pagination = node.querySelector('[data-slider-pagination]');
    pagination.style.top = `${slideHeight + 16}px`;
  };

  const initSlider = () => {
    mainSwiper = new Swiper(sliderEl, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      autoHeight: false,
      loop: true,
      centeredSlides: true,
      pagination: {
        el: paginationEl,
        type: 'custom',

        renderCustom: function (swiper, current, total) {
          // Adjust the total count based on your duplication logic
          const adjustedTotal = total / 2; // Assuming the slides are doubled for looping

          // Normalize the current slide index within the range of unique slides
          let adjustedCurrent = current % adjustedTotal;
          if (adjustedCurrent === 0) {
            adjustedCurrent = adjustedTotal; // Fix for when modulus gives 0 (last slide in loop)
          }

          return `${adjustedCurrent} / ${adjustedTotal}`;
        },
      },
      breakpoints: {
        320: {
          slidesPerView: sliderBreakpoints['320'],
        },
        480: {
          slidesPerView: sliderBreakpoints['480'],
        },
        768: {
          slidesPerView: sliderBreakpoints['768'],
        },
        1340: {
          slidesPerView: sliderBreakpoints['1340'],
        },
        1800: {
          slidesPerView: sliderBreakpoints['1800'],
        },
      },
      on: {
        init: function () {
          changePaginationPosition();
        },
      },
    });

    nextEl.forEach((el) => {
      el.addEventListener('click', nextSlide);
    });
    prevEl.forEach((el) => {
      el.addEventListener('click', prevSlide);
    });
  };

  /**
   * Init
   */
  initSlider();
  // check window resize
  window.addEventListener('resize', changePaginationPosition);
};
